import instance from "../../../api";
import {UserDataRes} from "../types";

export const getUserProfileInfo = (): Promise<UserDataRes> => {
  return instance(true).get("/core/commons/user-info/").then(res => res?.data);
};